import React, {
    useEffect,
    useState
} from "react";

const AdminMoments = () => {

    const [stats, setStats] =
        useState({
            activeMoments: 0,
            activeCreators: 0
        });

    const [loading, setLoading] =
        useState(true);

    const [error, setError] =
        useState("");


    useEffect(() => {

        const loadStats =
            async () => {

                try {

                    setLoading(true);
                    setError("");

                    const token =
                        localStorage.getItem(
                            "authToken"
                        );

                    const authHeader =
                        token?.startsWith(
                            "Bearer "
                        )
                            ? token
                            : `Bearer ${token}`;

                    const response =
                        await fetch(
                            `${process.env.REACT_APP_API_URL}/api/admin/moments/stats`,
                            {
                                headers: {
                                    Authorization:
                                        authHeader
                                }
                            }
                        );

                    const data =
                        await response
                            .json()
                            .catch(() => null);

                    if (!response.ok) {

                        throw new Error(
                            data?.message ||
                            "Unable to load Moment statistics."
                        );
                    }

                    setStats({
                        activeMoments:
                            Number(
                                data?.activeMoments ||
                                0
                            ),

                        activeCreators:
                            Number(
                                data?.activeCreators ||
                                0
                            )
                    });

                } catch (error) {

                    console.error(
                        "Moment stats error:",
                        error
                    );

                    setError(
                        error.message ||
                        "Unable to load Moment statistics."
                    );

                } finally {

                    setLoading(false);
                }
            };

        loadStats();

    }, []);


    return (

        <div
            style={{
                minHeight:
                    "calc(100vh - 70px)",
                background:
                    "#f6f7fb",
                padding:
                    "32px"
            }}
        >

            <div
                style={{
                    maxWidth:
                        "1200px",
                    margin:
                        "0 auto"
                }}
            >

                <div
                    style={{
                        marginBottom:
                            "28px"
                    }}
                >

                    <div
                        style={{
                            display:
                                "inline-block",
                            background:
                                "#fff0f5",
                            color:
                                "#ff4f88",
                            padding:
                                "7px 12px",
                            borderRadius:
                                "999px",
                            fontSize:
                                "12px",
                            fontWeight:
                                "800",
                            marginBottom:
                                "10px"
                        }}
                    >
                        MOMENTS
                    </div>

                    <h1
                        style={{
                            margin: 0,
                            fontSize:
                                "30px",
                            color:
                                "#18181b"
                        }}
                    >
                        Moments Overview
                    </h1>

                    <p
                        style={{
                            marginTop:
                                "8px",
                            color:
                                "#71717a"
                        }}
                    >
                        Current activity from active Moments.
                    </p>

                </div>


                {loading && (

                    <div
                        style={{
                            background:
                                "#fff",
                            padding:
                                "24px",
                            borderRadius:
                                "18px"
                        }}
                    >
                        Loading Moment statistics...
                    </div>

                )}


                {error && (

                    <div
                        style={{
                            background:
                                "#fff",
                            padding:
                                "20px",
                            border:
                                "1px solid #fecaca",
                            borderRadius:
                                "16px",
                            color:
                                "#b91c1c"
                        }}
                    >
                        {error}
                    </div>

                )}


                {!loading && !error && (

                    <div
                        style={{
                            display:
                                "grid",
                            gridTemplateColumns:
                                "repeat(auto-fit, minmax(260px, 1fr))",
                            gap:
                                "20px"
                        }}
                    >

                        <MomentCard
                            title="Active Moments"
                            value={
                                stats.activeMoments
                            }
                            description="Moments currently visible on the platform"
                        />

                        <MomentCard
                            title="Active Creators"
                            value={
                                stats.activeCreators
                            }
                            description="Users who currently have at least one active Moment"
                        />

                    </div>

                )}

            </div>

        </div>
    );
};


const MomentCard = ({
    title,
    value,
    description
}) => {

    return (

        <div
            style={{
                background:
                    "#fff",
                borderRadius:
                    "20px",
                padding:
                    "26px",
                border:
                    "1px solid #eeeeF2",
                boxShadow:
                    "0 8px 28px rgba(15,23,42,.05)"
            }}
        >

            <div
                style={{
                    fontSize:
                        "14px",
                    fontWeight:
                        "700",
                    color:
                        "#71717a"
                }}
            >
                {title}
            </div>

            <div
                style={{
                    marginTop:
                        "10px",
                    fontSize:
                        "38px",
                    fontWeight:
                        "850",
                    color:
                        "#18181b"
                }}
            >
                {value}
            </div>

            <div
                style={{
                    marginTop:
                        "14px",
                    paddingTop:
                        "14px",
                    borderTop:
                        "1px solid #f1f1f4",
                    fontSize:
                        "13px",
                    lineHeight:
                        "1.5",
                    color:
                        "#a1a1aa"
                }}
            >
                {description}
            </div>

        </div>
    );
};


export default AdminMoments;